import { useState } from "react";
import { Crown, Menu, X } from "lucide-react";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { useDonate } from "./shared";

const LINKS = [
  { label: "The Mission", href: "#mission" },
  { label: "The Gala", href: "#gala" },
  { label: "Adult Prom", href: "#adult-prom" },
  { label: "Tickets", href: "#tickets" },
  { label: "Sponsor", href: "#sponsor" },
  { label: "After Party", href: "#after-party" },
];

const Navbar = () => {
  const { openDonate } = useDonate();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-[70] glass border-b border-champagne/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[72px] flex items-center justify-between gap-4">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0">
          <span className="w-9 h-9 rounded-full bg-gradient-to-br from-gold to-wine flex items-center justify-center">
            <Crown size={17} className="text-ivory" />
          </span>
          <span className="leading-none">
            <span className="block font-serif text-sm sm:text-base tracking-[0.14em] text-ivory">
              STYLES 4 KIDZ
            </span>
            <span className="block text-[9px] sm:text-[10px] uppercase tracking-[0.3em] text-gold mt-1">
              Building Crowns Gala
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              href={l.href}
              className="text-[11px] uppercase tracking-[0.22em] text-cream/80 hover:text-champagne transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <button
            data-testid="nav-donate-button"
            onClick={() => openDonate()}
            className="hidden sm:inline-flex items-center px-5 py-2.5 rounded-full border border-champagne/50 text-champagne text-[11px] uppercase tracking-[0.2em] font-semibold hover:bg-champagne/10 transition-colors"
          >
            Give Now
          </button>
          <a
            data-testid="nav-buy-tickets-button"
            href={EVENT_CONFIG.urls.buyTickets}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center px-5 py-2.5 rounded-full bg-gradient-to-r from-gold via-champagne to-gold text-ink text-[11px] uppercase tracking-[0.2em] font-bold hover:shadow-[0_10px_30px_-8px_rgba(230,199,134,0.6)] transition-shadow"
          >
            Buy Tickets
          </a>
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-ivory p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-drawer"
          className="lg:hidden glass border-t border-champagne/10 px-6 py-8 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.25em] text-cream hover:text-champagne transition-colors"
            >
              {l.label}
            </a>
          ))}
          <div className="flex gap-3 pt-4">
            <button
              data-testid="nav-mobile-donate-button"
              onClick={() => {
                setOpen(false);
                openDonate();
              }}
              className="flex-1 py-3.5 rounded-full border border-champagne/50 text-champagne text-xs uppercase tracking-[0.2em] font-semibold"
            >
              Give Now
            </button>
            <a
              data-testid="nav-mobile-buy-tickets-button"
              href={EVENT_CONFIG.urls.buyTickets}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 py-3.5 rounded-full bg-gradient-to-r from-gold via-champagne to-gold text-ink text-xs uppercase tracking-[0.2em] font-bold text-center"
            >
              Buy Tickets
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
